import { render, staticRenderFns } from "./CompositionApiExampleTemplate.vue?vue&type=template&id=10ab5b09&"
import script from "./CompositionApiExampleTemplate.vue?vue&type=script&lang=js&"
export * from "./CompositionApiExampleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports